import { ALIGN_TO_JUSTIFY_CONTENT } from "@client/content/Containers/Text/selectors";
import { combinedSettingsSelector, type SettingsPropsParametricSelector, TargetSelector } from "@client/selectors";
import { createSelector } from "reselect";

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "hoverColor", path: "icon", prop: "hoverColor", type: "color" },
    { name: "backgroundHoverColor", path: "icon", prop: "backgroundHoverColor", type: "color" },
    { name: "borderHoverColor", path: "icon", prop: "borderHoverColor", type: "color" },
    { name: "size", path: "icon", prop: "size" },
    "alignText",
    "spacing"
  ]);

  return createSelector(
    [settingsSelector],
    (settings): React.CSSProperties =>
      ({
        "--hover-color": settings!.hoverColor,
        "--hover-bgc": settings!.backgroundHoverColor,
        "--hover-bc": settings!.borderHoverColor,
        "--size": settings!.size,
        gap: settings!.spacing,
        justifyContent: ALIGN_TO_JUSTIFY_CONTENT[settings.alignText]
      } as React.CSSProperties)
  );
};
